/** Decide before UIKit's scroll pan activates; a hold belongs to its scrollbar grab. */
export const DRAWER_OPENING_HORIZONTAL_DISTANCE = 8;
export const DRAWER_OPENING_VERTICAL_TOLERANCE = 6;
const SCROLLBAR_GRAB_DELAY_MS = 250;

/** Only called before activation. Once scrolling wins, the drawer fails for this entire touch. */
export function getDrawerOpeningTouchIntent({
  distanceX,
  distanceY,
  elapsedMs,
}: {
  distanceX: number;
  distanceY: number;
  elapsedMs: number;
}): "pending" | "drawer" | "scroll" {
  "worklet";

  const verticalDistance = Math.abs(distanceY);
  if (
    elapsedMs >= SCROLLBAR_GRAB_DELAY_MS ||
    verticalDistance >= DRAWER_OPENING_VERTICAL_TOLERANCE ||
    distanceX >= DRAWER_OPENING_HORIZONTAL_DISTANCE
  ) {
    return "scroll";
  }
  if (distanceX <= -DRAWER_OPENING_HORIZONTAL_DISTANCE && -distanceX >= verticalDistance * 1.5) {
    return "drawer";
  }
  return "pending";
}
